<template>
  <button
    type="button"
    data-qa="remove"
    :disabled="disabled"
    :class="$style.removeButton"
    @click="emit('click')"
  >
    <base-icon
      type="remove"
      :width="14"
      :height="14"
    />
  </button>
</template>

<script setup lang="ts">
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';

const { disabled = false } = defineProps<{
  disabled?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<style module>
.removeButton {
  @mixin reset-button-styles;
  color: #cccccc;
  opacity: 0.5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--removebutton-width);
  height: 30px;
  &:hover {
    opacity: 1;
  }
}
</style>

<i18n lang="json">{}</i18n>
